(function () {
    'use strict';

    angular.module('app').controller('CategoriesController', CategoriesController);

    CategoriesController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        '$timeout',
        '$filter',
        'blockUI',
        'GoodsService',
        'SelectService',
        'NotifyService',
        'LANGS',
        'SettingsService',
        '$uibModal'
    ];

    function CategoriesController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        $timeout,
        $filter,
        blockUI,
        GoodsService,
        SelectService,
        NotifyService,
        LANGS,
        SettingsService,
        $uibModal
    ) {

        $scope.isPageMode = isPageMode;

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.getGoodsCategoriesList = SelectService.getGoodsCategoriesList;
        $scope.filterHelper = {};

        $scope.isURLValid = isURLValid;

        $scope.multilang = MultilanguageHelper();
        $scope.initLocaleStrings = initLocaleStrings;

        $scope.data = {
            // Category picture
            image: {
                src: '',
                cropped: '',
                new: false,
                delete: false
            },
            // Category color
            colors: ['ffffff', '2ecc71', '2980b9', '8e44ad', '2c3e50', 'f1c40f', 'e67e22', 'd35400', 'c0392b', 'bdc3c7', '98a3a3']
        };

        var block_categories_list = blockUI.instances.get('categories_list'),
            block_category_edit = blockUI.instances.get('category_edit'),
            categoriesTimeout;

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../client-accounts/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('category_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';
        }

        /**
         * Initialize controller
         */
        function initController() {

            $scope.multilang.initLangs(LANGS, $rootScope.LANG);
            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;

                case 'show':
                    doShow();
                    break;

                case 'edit':
                    doEdit();
                    break;
            }
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        /**
         * Prepare data for display page in mode 'show'
         */
        function doShow() {
            if ($scope.filterHelper.id) {
                loadCategories();

                $timeout.cancel(categoriesTimeout);
            } else {
                categoriesTimeout = $timeout(doShow, 250);
            }
        }

        /**
         * Load Goods Categories
         * @param fromStart: (bool) Set True if paging need reset
         */
        function loadCategories() {

            block_categories_list.start();

            var params = {
                only_active: !$scope.data.showDisabledItems
            };
            GoodsService.Categories($scope.filterHelper.id, params, function (success, data) {
                if (success)
                    $scope.categoriesList = data;

                for (var i in $scope.categoriesList)
                    setTreeNodes($scope.categoriesList[i]);

                block_categories_list.stop();
            });

        }

        /**
         * Specified Account active state
         * @param news: News object
         */
        // $scope.itemActive = function (account) {
        //     // return account.active == 1;
        // };

        /**
         * Received when user change filter
         * @param id - Loyalty id
         */
        $scope.onSelectFilter = function (id, item) {
            loadCategories();
        };

        $scope.onChangeShowOnlyActive = function () {
            loadCategories();
        };

        /**
         * Click on 'Create category' button
         */
        $scope.onCreateCategoryClick = function () {
            $location.path('/categories/create');
        };

        /**
         * Category enable/disable click
         */
        $scope.onCategoryToggle = function (category) {
            block_categories_list.start();

            var active = 1 * !Boolean(category.active);
            var nodes_to_process = [];

            function processTreeNodes(category) {
                var result;
                nodes_to_process.push({
                    id: category.id,
                    loyalty_id: category.loyalty_id,
                    title: category.title,
                    active: active
                });

                if (category.nodes && category.nodes.length > 0) {
                    for (var i in category.nodes) {
                        processTreeNodes(category.nodes[i]);
                    }
                }
            }

            processTreeNodes(category);

            var current = 0;
            var total = nodes_to_process.length - 1;

            function handleResult(success, data) {
                if (success) {
                    if (current < total) {
                        current++;
                        GoodsService.CategoryEdit(nodes_to_process[current].id, nodes_to_process[current], handleResult);
                    } else {
                        loadCategories();
                        block_categories_list.stop();
                    }
                }
            }

            GoodsService.CategoryEdit(nodes_to_process[current].id, nodes_to_process[current], handleResult);
        };

        /**
         * handling color selector in edit/create category
         */
        $scope.onColorSelectClick = function (color) {
            $scope.data.color = color;
        };

        // *********************************************************************************************
        //  CREATE & EDIT PART
        // *********************************************************************************************

        /**
         * Init loyalty string
         */
        function initLocaleStrings(goods_category) {
            $scope.multilang.initStrings(goods_category, ['public_title', 'public_description']);
        }

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
        };

        /**
         * Raised when user select local file
         * @param evt
         */
        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }

                    $scope.$apply(function () {
                        $scope.data.image.cropped = '';
                        $scope.data.image.loading = false;
                        $scope.data.image.new = true;
                        $scope.data.image.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        };
        //angular.element('#NewsPicture').on('change', $scope.handleFileSelect);

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('categoryPicture'));
            file.on('change', $scope.handleFileSelect);
        };

        function doCreate() {
            $scope.model = {
                loyalty_id: $rootScope.ENV.LastLoyalty,
                color: 4294967295,
                active: 1,
                parent_id: '0'
            };

            $scope.initLocaleStrings($scope.model);

            $scope.data.color = intToHEX($scope.model.color);
        }

        $scope.onSaveCategoriesClick = function () {
            block_categories_list.start();

            var loyalty_id = $scope.filterHelper.id;
            var post_data = angular.copy($scope.categoriesList);
            GoodsService.CategoriesEdit(loyalty_id, post_data, function (success, data) {
                if (success) {
                    $scope.categoriesList = data;

                    for (var i in $scope.categoriesList)
                        setTreeNodes($scope.categoriesList[i]);

                    block_categories_list.stop();
                }
            });
        };

        function doEdit() {
            block_category_edit.start();

            function _startEdit() {
                $scope.model = angular.copy($scope.selected);

                if (!$scope.model.parent_id)
                    $scope.model.parent_id = '0';

                $scope.initLocaleStrings($scope.model);

                $scope.data.color = intToHEX($scope.model.color);

                block_category_edit.stop();
            }

            GoodsService.Category($routeParams.category_id, function (success, data) {
                if (success) {
                    $scope.selected = data;
                    _startEdit();
                } else {
                    $location.path('/categories');
                }
            });
        }

        $scope.deleteCategoryPhoto = function () {
            if ($scope.data.image.new) {
                $scope.data.image.src = '';
                $scope.data.image.cropped = '';
                $scope.data.image.new = false;
            } else if ($scope.model.image) {
                delete $scope.model.image;
                $scope.data.image.delete = true;
            }
        };

        $scope.cropCategoryPhoto = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.data.image);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.data.image = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        /**
         * Saving category
         */
        $scope.saveCategoryChanges = function (form, needClose) {
            function receiveResult(success, data) {
                if (success) {
                    NotifyService.Success('', false);
                    if ($scope.data.image.delete && !$scope.data.image.new) {
                        GoodsService.DeleteCategoryPhoto(data.id, function (success, img_data) {
                            if (success) {
                                $scope.model = img_data;
                                $scope.data.image.delete = false;
                            }
                            if (success) {
                                if (needClose) $location.path('/categories');
                            }
                        });
                    } else if ($scope.data.image.new) {
                        var image = $scope.data.image.cropped || $scope.data.image.src;
                        GoodsService.UploadCategoryPhoto(data.id, image, function (success, category) {
                            if (success) {
                                $scope.model = category;
                                $scope.data.image.new = false;
                                $scope.data.image.delete = false;
                                if (needClose) $location.path('/categories');
                            }
                        });
                    } else {
                        $scope.model = data;
                        if (needClose) $location.path('/categories');
                    }
                }
                block_category_edit.stop();
            }

            block_category_edit.start();

            $scope.model.color = hexToInt($scope.data.color);
            var post_data = $scope.model;

            if (post_data.parent_id == '0')
                //delete post_data.parent_id;
                post_data.parent_id = null;

            if (form.title.$valid) {
                if ($scope.isPageMode('create')) {
                    var loyalty_id = $scope.filterHelper.id;
                    GoodsService.CategoryAdd(loyalty_id, $scope.model, receiveResult);
                } else {
                    GoodsService.CategoryEdit(post_data.id, post_data, receiveResult);
                }
            } else {
                form.title.$dirty = true;
                block_category_edit.stop();
            }
        };

        /**
         * Adding empty nodes array to node, for it required for tree drag and drop
         */
        function setTreeNodes(node) {
            if (node.nodes)
                for (var i in node.nodes) {
                    setTreeNodes(node.nodes[i]);
                }
            else {
                node.nodes = [];
            }
        }

        /**
         * Cancel editing
         */
        $scope.onCancelEdit = function () {
            $location.path('/categories');
        };

        // $scope.$watch('categoriesList', function() {
        //     if ($scope.categoriesList)
        //         console.error("1");
        // }, true);
        //

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($rootScope.ENV.filters && $rootScope.ENV.filters.categories_list && $rootScope.ENV.filters.categories_list.loyalty_id)
                    $scope.filterHelper.id = $rootScope.ENV.filters.global_filter.loyalty_id;

                if (!$scope.filterHelper.id)
                    $scope.filterHelper.id = getFirstActive($scope.data.loyaltiesList).id;

                if ($scope._pageMode === 'create' || $scope._pageMode === 'edit') {
                    $scope.getGoodsCategoriesList($scope.filterHelper.id, function (success, response) {
                        $scope.data.categoriesList = angular.copy($rootScope.GOODS_CATEGORIES_FLAT[$scope.filterHelper.id]);
                        $scope.data.categoriesList.unshift({
                            id: '0',
                            active: 1,
                            title: $filter('translate')('Root category')
                        });
                    });
                }
            }
        });

        $scope.$watch('filterHelper.id', function (newValue, oldValue, scope) {
            if (newValue && newValue !== oldValue) {
                $scope.getGoodsCategoriesList(newValue, function (success, response) {
                    $scope.data.categoriesList = angular.copy(response);
                    $scope.data.categoriesList.unshift({
                        id: '0',
                        active: 1,
                        title: $filter('translate')('Root category')
                    });
                });

                if ($scope._pageMode === 'show') {
                    doShow();

                    $rootScope.ENV.filters.categories_list = {
                        loyalty_id: newValue
                    };

                    $rootScope.ENV.filters.global_filter = {loyalty_id: newValue};
                    $rootScope.storeENV();
                }
            }
        });

    }
})();
